import React from 'react';
import { Flex } from '@chakra-ui/layout';

export const ColorfulBar: React.VFC = () => {
  return (
    <Flex w="100%" bg="blue" h="6px" justify="flex-end">
      <Flex bg="green.900" w="4%" h="100%" />
      <Flex bg="yellow" w="4%" h="100%" />
      <Flex bg="orange.200" w="4%" h="100%" />
      <Flex bg="pink" w="4%" h="100%" />
      <Flex bg="purple.400" w="4%" h="100%" />
    </Flex>
  );
};
